export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/hu.lyaml"));
at({ "hu": { "public": { "sampleString": "Minta karakterl\xE1nc" } } });
};